module.exports = __webpack_public_path__ + "static/media/physics.5feea40a.png";